module.exports = __webpack_public_path__ + "static/media/galerija_2017 (39).0fc0f8c3.jpg";